import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchGetAdminWarehouse,
  fetchGetFulFillmentTypes,
  fetchPostWarehouseCorrection,
} from '../../../../actions/admin';
import styled from '@emotion/styled';
import { parseError, preventSubmittingByEnter } from '../../../../helpers';
import { DELIVERY_INFO_MODS, WAREHOUSE_INFO_MODS } from '../../../../config';
import { useRef } from 'react';
import List from './components/List';
import Info from './components/Info';
import Button from '../../../common/Button';

const TableContainer = styled('div')`
  overflow-y: hidden;
  overflow-x: hidden;
  padding: 0 !important;

  .form-control[type='checkbox'] {
    width: 16px;
    height: 16px;
  }
`;

const Warehouse = (props) => {
  const { values, handleChangeInput, setCheckedWarehouses } = props;
  const dispatch = useDispatch();
  const [mode, setMode] = useState(WAREHOUSE_INFO_MODS.LIST);
  const [currentWarehouse, setCurrentWarehouse] = useState(null);
  const targetElement = useRef();
  const { fulfillmentType } = useSelector((state) => state.admin);
  const [isNew, setIsNew] = useState(false);

  const handleSwitchMode = (mode, delivery, createNewWarehouse) => {
    if (createNewWarehouse === true) {
      setIsNew(true);
    } else {
      setIsNew(false);
    }

    setMode(mode);
    if (delivery) {
      setCurrentWarehouse(delivery);
    }
    const el = targetElement;
    el.current.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'start',
    });
  };

  useEffect(() => {
    dispatch(fetchGetFulFillmentTypes());
  }, []);

  const displayWarehouseComponent = () => {
    switch (mode) {
      case WAREHOUSE_INFO_MODS.LIST:
        return (
          <List
            values={values}
            handleChangeInput={handleChangeInput}
            setCheckedWarehouses={setCheckedWarehouses}
            handleSwitchMode={handleSwitchMode}
          />
        );
      case WAREHOUSE_INFO_MODS.INFO:
        return (
          <Info
            handleSwitchMode={handleSwitchMode}
            mode={mode}
            item={currentWarehouse}
            fulfillmentType={fulfillmentType}
          />
        );
      case WAREHOUSE_INFO_MODS.EDIT:
        return (
          <Info
            handleSwitchMode={handleSwitchMode}
            mode={mode}
            item={currentWarehouse}
            fulfillmentType={fulfillmentType}
            isNew={isNew}
          />
        );
      default:
        return <p>Загрузка</p>;
    }
  };

  useEffect(() => {
    dispatch(fetchGetAdminWarehouse());
  }, [dispatch]);

  return (
    <div onKeyDown={preventSubmittingByEnter} ref={targetElement}>
      <div
        className="border-bottom"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingBottom: '20px',
        }}
      >
        <h4 className="header-title">{isNew ? 'Создание нового склада' : 'Склады'}</h4>

        {mode === WAREHOUSE_INFO_MODS.LIST && (
          <Button
            text="Создать склад"
            onClick={() => handleSwitchMode(WAREHOUSE_INFO_MODS.EDIT, {}, true)}
          />
        )}
      </div>
      <TableContainer>
        {values.warehouses && <div>{displayWarehouseComponent()}</div>}
      </TableContainer>
    </div>
  );
};

export default Warehouse;
